import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { saveServiceProviders } from "../../api";
import { FORM_FIELDS, FORM_TEXTS, FORM_VALIDATION } from "../../constants";
import { LeftBanner } from "../../layout/LeftBanner";
import { NavBar } from "../../layout/NavBar";
import { setNotification } from "../../redux/notificationSlice";
import { FormTextInput } from "../core";
import { ContactDetails } from "../forms/ContactDetails";
import { FormButtons } from "../forms/FormButtons";
import { VendorDetails } from "../forms/VendorDetails";
import { ServiceOfferingTags } from "./ServiceOfferingTags";

export const UpdateVendor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [isUpdated, setIsUpdated] = useState(false);
  const [tags, setTags] = useState([]);
  const [createTagError, setCreateTagError] = useState(false);
  const updateFormData = Array.isArray(state) ? state[0] : state;
  const dispatch = useDispatch();

  const submitForm = async (data) => {
    data.id = updateFormData?.id;
    data.country = data.country?.value ?? "";
    delete data.servicesProvided;
    delete data.serviceCountries;
    if (tags.length === 0) {
      setCreateTagError(true);
      return;
    } else {
      setCreateTagError(false);
    }
    data.tags = tags;
    const requestData = {
      operation: "updateServiceProvider",
      request: data,
    };
    const saveResp = await saveServiceProviders(requestData);
    if (saveResp?.responseCode === 200) {
      setIsUpdated(true);
      dispatch(
        setNotification({
          type: "success",
          show: true,
          message: "Success! service provider updated successfully",
        })
      );
    } else if (saveResp?.responseCode === 400) {
      dispatch(
        setNotification({
          type: "error",
          show: true,
          message:
            "There has been an error occurred. Please contact the support for further assistance.",
        })
      );
    } else {
      dispatch(
        setNotification({
          type: "error",
          show: true,
          message:
            "There is some issue adding service provider. Please try again",
        })
      );
    }
  };

  useEffect(() => {
    if (isUpdated) {
      const timer = setTimeout(() => {
        navigate("/");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isUpdated, navigate]);

  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      serviceProviderName: updateFormData?.serviceProviderName,
      serviceProviderUrl: updateFormData?.serviceProviderURL,
      address: updateFormData?.address,
      country: {
        value: updateFormData?.country,
        label: updateFormData?.country,
      },
      primaryName: updateFormData?.primaryName,
      primaryEmail: updateFormData?.primaryEmail,
      primaryPhone: updateFormData?.primaryContact,
      primaryTitle: updateFormData?.primaryTitle,
      secondaryName: updateFormData?.secondaryName,
      secondaryEmail: updateFormData?.secondaryEmail,
      secondaryPhone: updateFormData?.secondaryContact,
      secondaryTitle: updateFormData?.secondaryTitle,
      requestId: updateFormData?.requestId,
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValue(name, value);
  };

  return (
    <>
      <NavBar />
      <div className="flex mr-4">
        <div className="flex-none w-64">
          <LeftBanner />
        </div>
        <div className="flex-1 pr-24">
          <div className="w-full">
            <h3 className="font-normal text-2xl text-teal-600">
              {FORM_TEXTS.UPDATE_RECORD}
            </h3>
            <div className="text-gray-500 mb-5">
              Note:{" "}
              All fields marked with (<span className="text-red-500 font-bold text-lg">*</span>) are mandatory.
            </div>
            <form className="my-5" onSubmit={handleSubmit(submitForm)}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 my-5">
                <VendorDetails
                  control={control}
                  register={register}
                  errors={errors}
                />
                <ServiceOfferingTags
                  tags={tags}
                  setTags={setTags}
                  state={state}
                />
                <div className="grid grid-cols-2 px-2">
                  {tags.length === 0 && createTagError && (
                    <span className="text-red-500 text-sm">
                      Please create atleast one tag.
                    </span>
                  )}
                </div>
                <div className="grid grid-cols-2 px-2"></div>
                <FormTextInput
                  value={state?.requestId}
                  labelName={FORM_FIELDS.REQUEST_ID}
                  id="requestId"
                  required={true}
                  disabledCheck={true}
                  {...register("requestId", {
                    required: FORM_VALIDATION.REQUEST_ID,
                  })}
                  error={errors.requestId}
                />
              </div>
              <ContactDetails
                register={register}
                errors={errors}
                handleChange={handleChange}
              />
              <FormButtons navigate={navigate} />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
